import { FC } from "react"
import { Layout } from "../../components/WelcomePage/Layout"

export const WelcomePage: FC = () => {
  return <Layout />
}
